"use client";

import { SessionProvider } from "next-auth/react";
import { TimezoneProvider } from "@/app/utils/TimezoneContext";
import VercelAnalytics from "@/lib/analytics/VercelAnalytics";

export default function PublicSessionProvider({ children, session }) {
  return (
    <SessionProvider session={session}>
      <TimezoneProvider>
        <VercelAnalytics />
        {children}
      </TimezoneProvider>
    </SessionProvider>
  );
}
